<template>
  <div class="category">
    <div>
      <el-button size="small" type="primary" @click="handleAdd">添加分类</el-button>
    </div>
    <div>
      <el-table :data="dataList" v-loading="loading">
        <el-table-column prop="id" label="分类ID" width="100px"></el-table-column>
        <el-table-column prop="name" label="分类名称"></el-table-column>
        <el-table-column label="操作" width="200px">
          <template slot-scope="{row}">
            <el-button type="primary" plain @click="handleEdit(row)">编辑</el-button>
            <el-button type="danger" @click="handleDelete(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="visibleEdit" :title="isEdit ? '编辑分类' : '添加分类'" width="400px">
      <el-form label-width="80px">
        <el-form-item prop="name" label="分类名称">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleEdit = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submit" :loading="buttonLoading">确 定</el-button>
      </span>
    </el-dialog>
    <el-pagination
      background
      :page-size="dataMeta.per_page || 15"
      :total="dataMeta.total || 0"
      :current-page="page"
      @current-change="handlePageChange"
      v-if="dataMeta && dataMeta.total > dataMeta.per_page"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { postData, patchData, delData } from '../../http'
export default {
  data() {
    return {
      editForm: {
        name: ''
      },
      page: 1,
      editId: undefined,
      loading: false,
      visibleEdit: false,
      buttonLoading: false,
      isEdit: false
    }
  },
  computed: {
    ...mapState({
      dataList: state => state.data.categoryList.data,
      dataMeta: state => state.data.categoryList.meta
    })
  },
  methods: {
    ...mapActions(['getCategoryList', 'getCategories']),
    getData() {
      this.loading = true
      this.getCategoryList({ page: this.page }).finally(() => {
        this.loading = false
      })
    },
    handleAdd() {
      this.isEdit = false
      this.editForm.name = ''
      this.visibleEdit = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.editForm.name = row.name
      this.editId = row.id
      this.visibleEdit = true
    },
    handlePageChange(page) {
      this.page = page
      this.getData()
    },
    handleDelete(id) {
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delData(`category/${id}`).then(res => {
          this.$message.success('删除成功')
          this.getData()
        })
      })
    },
    submit() {
      if (!this.editForm.name) {
        this.$message.error('请输入分类名称')
        return
      }
      this.buttonLoading = true
      if (this.isEdit && this.editId) {
        patchData(`category/${this.editId}`, {
          name: this.editForm.name
        })
          .then(res => {
            this.$message.success('编辑成功')
            this.visibleEdit = false
            this.getData()
            this.getCategories()
          })
          .finally(() => {
            this.buttonLoading = false
          })
      } else {
        postData('category', {
          name: this.editForm.name
        })
          .then(res => {
            this.$message.success('添加成功')
            this.visibleEdit = false
            this.getData()
            this.getCategories()
          })
          .finally(() => {
            this.buttonLoading = false
          })
      }
    }
  },
  created() {
    this.getData()
  }
}
</script>

<style>
</style>
